// extracted by mini-css-extract-plugin
export default {"wrapper":"SiteContentWrapper_wrapper__K2N9y","container":"SiteContentWrapper_container__Y2xnE"};